import React from 'react';

import { pdf } from '@react-pdf/renderer';
import { MultiPrintEpaysage } from '@repo/print-pdf/epaysage/print-alt';


import { useRouter } from '@repo/ui/hooks/use-router';
import { InventoryService } from '@repo/ui/lib/api/services/inventory.service';
import { useMultiPrintData } from '@repo/ui/features/inventaires/hooks/use-multi-print-data';
import { Button } from '@repo/ui';
import { ArrowLeft } from 'lucide-react';
import { MultiEpaysagePDFDocument } from '@repo/print-pdf';

export default function MultiPrintEpaysagePage() {


  const router = useRouter();

  // Load inventaire IDs from storage
  const [inventaireIds, setInventaireIds] = React.useState<number[]>([]);
  const [inventaires, setInventaires] = React.useState<any[]>([]);
  const [isInitializing, setIsInitializing] = React.useState(true);
  const [isGeneratingPDF, setIsGeneratingPDF] = React.useState(false);

  React.useEffect(() => {
    const inventoryService = new InventoryService();
    const storedInventaires = inventoryService.getInventairesToPrint();

    if (storedInventaires && storedInventaires.length > 0) {
      // Extract IDs from stored inventaires
      const ids = storedInventaires.map((inv: any) => inv?.id).filter((id: any): id is number => !!id);
      setInventaireIds(ids);
      setInventaires(storedInventaires);
    }
    setIsInitializing(false);
  }, []);

  // Fetch print data from backend using the new hook
  const {
    printDataList: printDataFromBackend,
    isLoading: isLoadingPrintData,
  } = useMultiPrintData(inventaireIds.length > 0 ? inventaireIds : []);

  const printDataList = printDataFromBackend;
  const isLoading = isInitializing || (isLoadingPrintData && printDataList.length === 0);
  const handleDownloadPDF = async (_printDataList: any, epaysageIds: number[]) => {
    try {
      const blob = await pdf(
        <MultiEpaysagePDFDocument printDataList={_printDataList as any} epaysageIds={epaysageIds} />
      ).toBlob();
      console.log('blob', blob);
      if (!blob) {
        throw new Error('Impossible de générer le blob PDF');
      }
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `espece-boise-${_printDataList.length}-fiches.pdf`;
      link.click();
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Erreur génération PDF:', error);
      alert('Erreur lors de la génération du PDF');
      throw error;
    } finally {
      setIsGeneratingPDF(false);
    }
  }

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary mx-auto"></div>
          <p className="mt-4 text-lg">Chargement des inventaires...</p>
        </div>
      </div>
    );
  }

  const handleBack = () => {
    // Clean up stored data when leaving
    const inventoryService = new InventoryService();
    inventoryService.destroyInventairesToPrint();
    router.back();
  };

  if (!isLoading && (!inventaireIds || inventaireIds.length === 0)) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-red-600 mb-4">Erreur</h1>
          <p className="text-muted-foreground mb-4">
            Aucun inventaire sélectionné pour l'impression
          </p>
          <Button onClick={handleBack} variant="outline">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Retour
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full py-6">
      <div className="print:hidden fixed top-4 right-4 z-50">
        <button
          onClick={() => handleDownloadPDF(printDataList, inventaireIds)}
          className="flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-md shadow-lg transition-colors"
        >
          {isGeneratingPDF ? 'Génération...' : 'Télécharger PDF'}
        </button>
      </div>
      <MultiPrintEpaysage printDataList={printDataList} inventaireIds={inventaireIds} inventaires={inventaires} />
    </div>
  );
}
